import * as XLSX from "xlsx";
import "./Excel.css";

export const generateExcel = (invoice) => {
  const calculateSummary = (shifts) => {
    const totalShifts = shifts.length;
    const totalHours = shifts.reduce((sum, shift) => sum + shift.hours, 0);
    const totalAmount = shifts.reduce((sum, shift) => sum + shift.amount, 0);
    const payableExpenses = shifts.reduce((sum, shift) => sum + shift.payableExpenses, 0);
    const totalPenalties = shifts.reduce((sum, shift) => sum + shift.penalty, 0);
    const grossAmount = totalAmount + payableExpenses - totalPenalties;

    return {
      totalShifts,
      totalHours,
      totalAmount,
      payableExpenses,
      totalPenalties,
      grossAmount,
    };
  };

  var workbook = XLSX.utils.book_new();
  const summary = calculateSummary(invoice);
  const invoiceData = {
    companyName: "CERBERUS SECURITY SERVICES LIMITED",
    companyAddress: "C E M E Innovation Centre, RM13 8EU",
    date: "19-01-2025",
    period: "01-01-2025 - 19-01-2025",
    subcontractor: {
      id: "7",
      name: "ALLIANCE NORTH",
      address: "LONDON",
      contactNumber: "07534167708",
      email: "",
    },
    shifts: invoice,
    summary: summary,
  }

  // Create a new workbook
 

  // Add header information
  const headerData = [
    [invoiceData.companyName],
    [invoiceData.companyAddress],
    ["SUBCONTRACTOR INVOICE"],
    [`Date: ${invoiceData.date}`, `Period: ${invoiceData.period}`],
    [
      `S. ID: ${invoiceData.subcontractor.id}`,
      `Subcontractor Name: ${invoiceData.subcontractor.name}`,
      `Contact Number: ${invoiceData.subcontractor.contactNumber}`,
    ],
    [`Subcontractor Address: ${invoiceData.subcontractor.address}`],
    [], // Empty row for spacing
  ];

  // Add table headers
  const tableHeaders = [
    [
      "Site Name",
      "Employee Name",
      "Day",
      "Shift Date",
      "Start - End",
      "Hours",
      "Payable Rate",
      "Payable Exp",
      "Penalty",
      "Amount",
    ],
  ];

  // Convert shifts to rows
  const shiftRows = invoiceData.shifts.map((shift) => [
    shift.siteName,
    shift.employeeName,
    shift.day,
    shift.shiftDate,
    shift.startEnd,
    shift.hours,
    shift.payableRate,
    shift.payableExp,
    shift.penalty,
    shift.amount,
  ]);

  // Add summary rows
  const summaryData = [
    [], // Empty row for spacing
    ["Total Shifts Found", invoiceData.summary.totalShifts],
    ["Total Hours", invoiceData.summary.totalHours],
    ["Total Amount", `£${invoiceData.summary.totalAmount}`],
    ["Payable Expenses", `£${invoiceData.summary.payableExpenses}`],
    ["Total Penalties", `£${invoiceData.summary.totalPenalties}`],
    ["Gross Amount", `£${invoiceData.summary.grossAmount}`],
  ];

  // Combine all data
  const allData = [
    ...headerData,
    ...tableHeaders,
    ...shiftRows,
    ...summaryData,
  ];

  // Create worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(allData);

  // Style the company name (bold and centered)
  worksheet["A1"] = {
    v: invoiceData.companyName,
    s: {
      font: { bold: true },
      alignment: { horizontal: "center", vertical: "center" },
    },
  };

  // Style the table headers (green background)
  const headerRow = headerData.length; // Get the row number where headers start
  const headers = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];

  headers.forEach((col) => {
    const cellRef = `${col}${headerRow + 1}`;
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "90EE90" },
        },
        font: { bold: true },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }
  });

  // Merge cells for company name
  worksheet["!merges"] = [
    {
      s: { r: 0, c: 0 },
      e: { r: 0, c: headers.length - 1 },
    },
  ];

  // Set column widths
  const columnWidths = [
    { wch: 10 }, // SIN
    { wch: 40 }, // Site Name
    { wch: 20 }, // Employee Name
    { wch: 10 }, // Day
    { wch: 15 }, // Shift Date
    { wch: 15 }, // Start - End
    { wch: 10 }, // Hours
    { wch: 12 }, // Payable Rate
    { wch: 12 }, // Payable Exp
    { wch: 10 }, // Penalty
    { wch: 12 }, // Amount
  ];
  worksheet["!cols"] = columnWidths;

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice");

  // Generate Excel file
  XLSX.writeFile(workbook, "subcontractor-invoice.xlsx");
};

export default generateExcel;
